import * as React from 'react'

import { Chevron, type DirectionType } from '@factorialco/deprecated-design-system'

import * as styles from './index.vanilla.css'

interface Props {
  direction: DirectionType
}

const ExpandButton = (props: Props) => {
  const { direction } = props

  return (
    <div className={styles.expandButton}>
      <Chevron type="terciary" direction={direction} />
    </div>
  )
}

export default ExpandButton
